module.exports = __webpack_public_path__ + "img/1-Intersection 2.da77b940.png";